import React, { useEffect, useRef, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import axios from "axios";
import exportToExcel from "../Report/ExportExcel";

const passengerTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const thTdStyle = {
  padding: "8px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const thStyle = {
  backgroundColor: "#f2f2f2",
};

const Transactions = ({ prRef }) => {
  const [data, setData] = useState([]);

  const getTransactions = async () => {
    const response = await axios
      .get("transactions/", {})
      .then((res) => {
        const transactionsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger?.firstName} ${transaction.passenger?.lastName}`;
          const driverName = `${transaction.driver?.firstName} ${transaction.driver?.lastName}`;

          let newTrans = {
            ...transaction,
            passenger: { ...transaction.passenger, name: passengerName },
            driver: { ...transaction.driver, name: driverName },
          };

          return newTrans;
        });
        setData(transactionsWithMergedNames);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getTransactions();
  }, []);
  const columns = [
    "Id",
    "Passenger Name",
    "Passenger Phone",
    "Driver Name",
    "Driver Phone",

    "Total Price",
    "Revenue",

    "Date",
  ];

  return (
    <div ref={prRef}>
      <Header
        title={"Transactions Information"}
        subTitle={""}
      />
      <table style={passengerTableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={{ ...thTdStyle, ...thStyle }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((trip, index) => (
            <tr key={index}>
              <td style={thTdStyle}>{trip.id}</td>
              <td style={thTdStyle}>{trip?.passenger?.name}</td>
              <td style={thTdStyle}>{trip?.passenger?.phoneNumber}</td>

              <td style={thTdStyle}>{trip?.driver?.name}</td>
              <td style={thTdStyle}>{trip?.driver?.phoneNumber}</td>

              <td style={thTdStyle}>{trip?.revenue}</td>
              <td style={thTdStyle}>{trip?.actualPrice}</td>

              <td style={thTdStyle}>
                {new Date(trip.createdAt).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Footer />
    </div>
  );
};

export const exportExcelTransactions = async () => {
  const getTransactions = async () => {
    const response = await axios
      .get("transactions/", {})
      .then((res) => {
        const transactionsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger?.firstName} ${transaction.passenger?.lastName}`;
          const driverName = `${transaction.driver?.firstName} ${transaction.driver?.lastName}`;

          return {
            Id: transaction.id,
            "Passenger Name": passengerName,
            "Passenger Phone": transaction.passenger?.phoneNumber,
            "Driver Name": driverName,
            "Driver Phone": transaction.driver?.phoneNumber,
            "Total Price": transaction.revenue,
            Revenue: transaction.actualPrice,
            Date: new Date(transaction.createdAt).toLocaleString(),
          };
        });

        exportToExcel(transactionsWithMergedNames, "transactions", [
          "Id",
          "Passenger Name",
          "Passenger Phone",
          "Driver Name",
          "Driver Phone",
          "Total Price",
          "Revenue",
          "Date",
        ]);
      })
      .catch((err) => {});
  };

  getTransactions();
};

export default Transactions;
